import { render, staticRenderFns } from "./WhitelistsTable.vue?vue&type=template&id=6da79e8a&scoped=true&"
import script from "./WhitelistsTable.vue?vue&type=script&lang=js&"
export * from "./WhitelistsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da79e8a",
  null
  
)

export default component.exports